import axios from "axios";


const upload = async (url: string, shopId: string, file: File, onUploadProgress?: (event: { loaded: number, total: number }) => void) => {
   const http = axios.create({
      baseURL: url,
      headers: {
         "Content-type": "application/json"
      }
   });

   let formData = new FormData();
   formData.append("file", file);

   return http.post(shopId, formData, {
      headers: {
         "Content-Type": "multipart/form-data",
      },
      onUploadProgress
   }).then(value => value.data);
}

export const UploadService = (url:string, shopId: string) => {
   return async (file:File, onUploadProgress?: (event: {loaded: number, total: number}) => void) => {
      return await upload(url, shopId, file, onUploadProgress);
   }
}